/** Both sizes must match ONE available variant. Never mutates variants or cart. */
export function catalogMatches(record, selected) {
  for (const field of ['color','top','bottom']) if (selected[field] && record[field] !== selected[field]) return false;
  if (!selected.topSize && !selected.bottomSize) return true;
  return record.variants.some(v => v.available && (!selected.topSize || (record.topIndex >= 0 && v.options[record.topIndex] === selected.topSize)) && (!selected.bottomSize || (record.bottomIndex >= 0 && v.options[record.bottomIndex] === selected.bottomSize)));
}
/** Carry the exact available size pair into the native product/Quick Add URL. */
export function catalogVariant(record, selected) {
  if (!selected.topSize && !selected.bottomSize) return null;
  if (!catalogMatches(record, selected)) return null;
  return record.variants.find(v => v.available && (!selected.topSize || v.options[record.topIndex] === selected.topSize) && (!selected.bottomSize || v.options[record.bottomIndex] === selected.bottomSize)) || null;
}
export function catalogVariantUrl(original, variant, base) {
  const url = new URL(original, base);
  if (variant?.id) url.searchParams.set('variant', String(variant.id));
  return url.href;
}
const Base = globalThis.HTMLElement || class {};
class MadoriaCatalogFilters extends Base {
  connectedCallback() {
    this.abort?.abort(); this.observer?.disconnect(); this.abort = new AbortController();
    this.root = this.closest('[data-md-catalog]'); if (!this.root) return;
    this.controls = [...this.querySelectorAll('[data-md-filter]')];
    const params = new URL(location.href).searchParams;
    this.selected = Object.fromEntries(this.controls.map(c => [c.dataset.mdFilter, params.get(`md_${c.dataset.mdFilter}`) || '']));
    const disclosure=this.querySelector('[data-md-filter-details]');
    if(disclosure) disclosure.open=matchMedia('(min-width:750px)').matches || Object.values(this.selected).some(Boolean);
    this.refresh();
    this.addEventListener('change', e => { if (e.target.matches('[data-md-filter]')) { this.selected[e.target.dataset.mdFilter] = e.target.value; this.update(); } }, {signal:this.abort.signal});
    this.querySelector('[data-md-catalog-reset]').addEventListener('click', () => { for (const c of this.controls) this.selected[c.dataset.mdFilter] = c.value = ''; this.update(); }, {signal:this.abort.signal});
    // Native sorting rewrites its own parameters; retain our shareable selection.
    document.addEventListener('filter:update', () => this.update(), {signal:this.abort.signal});
    window.addEventListener('popstate', () => {
      const params = new URL(location.href).searchParams;
      this.selected = Object.fromEntries(this.controls.map(c => [c.dataset.mdFilter, params.get(`md_${c.dataset.mdFilter}`) || '']));
      this.refresh();
    }, {signal:this.abort.signal});
    this.observer = new MutationObserver(changes => {
      if (changes.some(change => [...change.addedNodes,...change.removedNodes].some(n => n.nodeType === 1 && (n.matches('[data-md-catalog-card]') || n.querySelector('[data-md-catalog-card]'))))) this.refresh();
    });
    this.observer.observe(this.root,{childList:true,subtree:true});
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  refresh() {
    this.records = [...this.root.querySelectorAll('[data-md-catalog-card]')].flatMap(card => {
      try {
        const data = JSON.parse(card.querySelector('[data-md-catalog-variants]').textContent);
        let topIndex = data.options.findIndex(n => /bluz|gór|top|longsleeve/i.test(n));
        let bottomIndex = data.options.findIndex(n => /spod|dół|bottom/i.test(n));
        if (data.options.length === 1) { if (card.dataset.top) topIndex=0; if (card.dataset.bottom) bottomIndex=0; }
        return [{card,color:card.dataset.color,top:card.dataset.top,bottom:card.dataset.bottom,...data,topIndex,bottomIndex}];
      } catch { return []; }
    });
    if (this.records.length !== this.root.querySelectorAll('[data-md-catalog-card]').length) { this.hidden=true; delete this.root.dataset.mdCatalogReady; this.root.querySelectorAll('[data-md-catalog-card]').forEach(c => {c.hidden=false;}); return; }
    for (const control of this.controls) {
      const key=control.dataset.mdFilter, values=new Set();
      for (const r of this.records) {
        if (key.endsWith('Size')) { const i=key==='topSize'?r.topIndex:r.bottomIndex; if(i>=0) r.variants.filter(v=>v.available).forEach(v=>values.add(v.options[i])); }
        else if (r[key]) values.add(r[key]);
      }
      const sizes=['XXS','XS','S','M','L','XL','XXL','XXXL'];
      const sorted=[...values].sort((a,b)=>key.endsWith('Size')&&sizes.includes(a)&&sizes.includes(b)?sizes.indexOf(a)-sizes.indexOf(b):a.localeCompare(b,'pl'));
      control.querySelectorAll('option:not(:first-child)').forEach(o=>o.remove());
      for (const value of sorted) control.add(new Option(value,value));
      if (this.selected[key]&&!values.has(this.selected[key])) control.add(new Option(this.selected[key],this.selected[key]));
      control.value=this.selected[key]; control.closest('label').hidden=!values.size&&!this.selected[key];
    }
    this.hidden=false; this.root.dataset.mdCatalogReady='true'; this.update(false);
  }
  update(writeUrl=true) {
    let count=0;
    for (const r of this.records) {
      const match=catalogMatches(r,this.selected); r.card.hidden=!match; if(match) count++;
      const variant=catalogVariant(r,this.selected);
      for (const link of r.card.querySelectorAll('a[href*="/products/"]')) {
        if (!link.dataset.mdOriginalHref) link.dataset.mdOriginalHref=link.getAttribute('href');
        link.href=catalogVariantUrl(link.dataset.mdOriginalHref,variant,location.href);
      }
    }
    const status=this.querySelector('[data-md-catalog-status]'); status.textContent=`${status.dataset.label} ${count} / ${this.records.length}`;
    this.querySelector('[data-md-catalog-empty]').hidden=count>0;
    if(writeUrl) { const url=new URL(location.href); for(const [key,value] of Object.entries(this.selected)) { if(value) url.searchParams.set(`md_${key}`,value); else url.searchParams.delete(`md_${key}`); } history.replaceState(history.state,'',url); }
  }
}
if(globalThis.customElements&&!customElements.get('madoria-catalog-filters')) customElements.define('madoria-catalog-filters',MadoriaCatalogFilters);
